import { render, staticRenderFns } from "./MenuItemRow.vue?vue&type=template&id=4b07614f&scoped=true&"
import script from "./MenuItemRow.vue?vue&type=script&lang=js&"
export * from "./MenuItemRow.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemRow.vue?vue&type=style&index=0&id=4b07614f&scoped=true&lang=scss&"
import style1 from "./MenuItemRow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b07614f",
  null
  
)

export default component.exports